export default __webpack_public_path__ + "static/media/iccupomadd.e7a4df23.svg";